<div class="loading-content center-flex">
    <div>
        <p class="msg">{{ loadingMessage || 'Loading Your Content' }} </p>

        <div class="center-flex">
            <mat-spinner diameter="45"></mat-spinner>
        </div>
    </div>
</div>